import * as THREE from "three";
import { useThree } from "@react-three/fiber";
import { useSelector } from "react-redux";
import {
  useEffect,
  useRef,
  Suspense,
  useState
} from "react";


import { OrbitControls, Sparkles, useGLTF, useHelper } from "@react-three/drei";
import Skybox from "./Skybox.jsx";
import { Last } from "./Last.jsx";
import gsap from "gsap";
import { Baloontwo } from "./Baloontwo.jsx";

const Experience = (props) => {
  const mode = useSelector((state) => state.reducer1.mode);
  const { nodes, materials } = useGLTF('/Lights.glb')
  const [maxDist,setMaxDist] = useState(800);

  const dirRef = useRef();
  const hemRef = useRef();
  const redref = useRef();
  const yellowref = useRef();

  useEffect(()=>{
if(600<window.innerWidth && window.innerWidth<900){
setMaxDist(1600)
}
else if(window.innerWidth<600){
setMaxDist(2000)
}
  },[])


  useEffect(() => {
    if (mode==="night") {
      gsap.to(dirRef.current, {
        castShadow: true,
        intensity: 0.2,
        duration: 2,
      });
      gsap.to(hemRef.current, {
        intensity: 0.5,
        duration: 2,
      });
    } else {
      gsap.to(dirRef.current, {
        castShadow: true,
        intensity: 2,
        duration: 2,
      });
      gsap.to(hemRef.current, {
        intensity: 1,
        duration: 2,
      });
    }
  }, [mode]);
  

  function ToneMapping() {
    const { gl, scene } = useThree(({ gl, scene }) => ({ gl, scene }));
    useEffect(() => {
      gl.antialias = true;
      gl.toneMapping = THREE.ACESFilmicToneMapping;
      gl.toneMappingExposure = 1.0;
      gl.shadowMap.enabled = true;
      gl.shadowMap.type = THREE.PCFSoftShadowMap;
      gl.outputColorSpace = THREE.SRGBColorSpace;
      gl.setPixelRatio(THREE.devicePixelRatio);
      gl.setSize(window.innerWidth, window.innerHeight)

     
    }, [gl, scene]);
    return <></>;
  }

  return (
    <>
      <group {...props} dispose={null} position={[0,0,200]}>

    

      
      <mesh
        name="RGP_redlight_emi"
        ref={redref}
        castShadow
        receiveShadow
        geometry={nodes.RGP_redlight_emi.geometry}
        material={materials['Emi_tex.001']}
        position={[0, 0, -92.951]}
        scale={0.025}
      />
      <mesh
        name="RGP_yellowlight_emi"
        ref={yellowref}
        castShadow
        receiveShadow
        geometry={nodes.RGP_yellowlight_emi.geometry}
        material={materials['Emi_tex.001']}
        position={[0, 0, -92.951]}
        scale={0.025}
      />
    </group>

    


      {!props.birdView && props.gallery==0 &&  (
        <OrbitControls
          makeDefault
          maxDistance={maxDist}
          minDistance={200}
          minPolarAngle={Math.PI / 3}
          maxPolarAngle={Math.PI / 2.1}
          enableDamping
          enablePan
          enableZoom
        />
      )}

   

     

      <Skybox yes={mode=="day"?false:true} />

      <directionalLight
        ref={dirRef}
        castShadow
        position={[-300, 380, 300]}
        intensity={1.5}
        shadow-normalBias={1.1}
        shadow-mapSize-width={4096}
        shadow-mapSize-height={4096}
        shadow-camera-near={0.1}
        shadow-camera-far={10000}
        shadow-camera-top={1000}
        shadow-camera-bottom={-1000}
        shadow-camera-left={-1000}
        shadow-camera-right={1000}
      />

      <hemisphereLight
        ref={hemRef}
        position={[0, 300, 0]}
        groundColor={new THREE.Color("0xA1DD70")}
        color={new THREE.Color().setHSL(0.6, 1, 0.6)}
        intensity={1.55}
      />

      <Suspense fallback={null}>

      <Baloontwo mode={mode}/>  
     
      <Last mode={mode} newsClick={()=>{props.newsClick()}}/>
 
      { mode=="night" && <Sparkles size={50} number={200} position={[0,3,280]} scale={[100,10,100]} speed={3} /> }

      </Suspense>

    
    </>
  );
};
useGLTF.preload('/Lights.glb')
export default Experience;
